import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IOptionAnyValue } from 'bricks/types';
import React, { useEffect, useState } from 'react';
import ProFormaSelector from 'views/Reports/components/ProFormaSelector/ProFormaSelector';
import { IComparisonReportData } from 'views/Reports/types';

export interface IProps {
    data: IComparisonReportData;
    removeSelectedDeal: (dealId: number) => void;
    updateSelectedProFormaId: (dealId: number, proFormaId: number) => void;
    isEditMode: boolean;
    isLoading?: boolean;
}

export const ColumnHeader = ({
    data, removeSelectedDeal, updateSelectedProFormaId, isEditMode, isLoading = false,
}: IProps) => {
    const [wasSelectionChanged, setWasSelectionChanged] = useState(false);
    const handleProFormaSelection = (option: IOptionAnyValue) => {
        setWasSelectionChanged(true);
        updateSelectedProFormaId(data.dealId, option.value);
    };

    useEffect(() => {
        if (wasSelectionChanged && !isLoading) {
            setWasSelectionChanged(false);
        }
    }, [isLoading]);

    let dealType = '';
    if (data.dealTypeName && data.dealAssetType) {
        dealType = `${data.dealAssetType} • ${data.dealTypeName}`;
    } else if (data.dealTypeName) {
        dealType = data.dealTypeName;
    } else if (data.dealAssetType) {
        dealType = data.dealAssetType;
    }

    return (
        data && (
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <div className="text-white h4">{data.dealName}</div>
                    <div>{dealType}</div>
                    <ProFormaSelector
                        dealId={Number(data.dealId)}
                        proFormaId={data.proFormaId}
                        onChangeProFormaSelection={handleProFormaSelection}
                        isLoading={isLoading && wasSelectionChanged}
                    />
                </div>
                {isEditMode && (
                    <div>
                        <FontAwesomeIcon className="icon my-auto cursor--pointer" icon={faXmark} onClick={() => removeSelectedDeal(data.dealId)} />
                    </div>
                )}
            </div>
        )
    );
};

export default ColumnHeader;
